var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submissionDueDateText)?_c('span',[_vm._v(_vm._s(_vm.submissionDueDateText))]):_c('span',{staticClass:"text-neutral-500"},[_vm._v("N/A")])}
var staticRenderFns = []

export { render, staticRenderFns }